import { AdvancedMarker, APIProvider, ControlPosition, Map, MapControl, MapMouseEvent, useMap } from "@vis.gl/react-google-maps";
import React, { useEffect, useRef, useState } from "react";
import MapHandler from "./MapHandler";
import PlaceAutocomplete from "./PlaceAutocomplete";
import Style from "./mapcomponent.module.scss";

/**
 *
 * 
 */
export type ILocation = {
  place?: google.maps.places.PlaceResult | null,
  lat: number,
  lng: number
}

interface MapComponentProps {
  onLocationSet?: (location: ILocation) => void; // Callback-Prop
  startLat?: number,
  startLng?: number,
  scrollZoom: boolean,
}

const InnerMap: React.FC<MapComponentProps> = ({ onLocationSet, startLat, startLng , scrollZoom}) => {

  const [geocoder, setGeocoder] = useState<google.maps.Geocoder | null>(null);
  const [selectedPlace, setSelectedPlace] = useState<google.maps.places.PlaceResult | null>(null);

  const [markerPosition, setMarkerPosition] = useState<{ lat: number, lng: number } | null>(null);
  const markerRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const map = useMap();

  const updateInputField = (address: google.maps.places.PlaceResult) => {

    // Setz die Adresse in das Suchfeld
    if (inputRef && inputRef.current && address.formatted_address) {
      inputRef.current.value = address.formatted_address;
    }

    if (onLocationSet) {
      const myLat: number = typeof markerRef.current?.position?.lat === 'function'
        ? markerRef.current.position.lat()
        : markerRef.current?.position?.lat ?? 0;
      const myLng: number = typeof markerRef.current?.position?.lng === 'function'
        ? markerRef.current.position.lng()
        : markerRef.current?.position?.lng ?? 0;
      onLocationSet({
        place: address,
        lat: myLat,
        lng: myLng,
      });
    }
  };

  useEffect(() => {
    if (window.google?.maps?.Geocoder && !geocoder) {
      setGeocoder(new google.maps.Geocoder());
    }
  }, [window.google?.maps]);

  const mapMouseEvent = (e: MapMouseEvent) => {
    const latLng = e.detail.latLng;
    if (!latLng) return;

    // Setze Marker-Position
    setMarkerPosition({ lat: latLng.lat, lng: latLng.lng });

    // Zentrieren
    if (map) {
      map.panTo(latLng);
    }
    if (markerRef.current) {
      markerRef.current.position = latLng;
    }

    geocoder?.geocode({ location: latLng }, (results, status) => {

      if (status === "OK" && results && results[0]) {
        setSelectedPlace(results[0]);
        updateInputField(results[0]);
      }

    });

  }

  useEffect(() => {
    if (!map || !window.google?.maps?.Geocoder) return;
    if (!geocoder) setGeocoder(new google.maps.Geocoder());
  }, [map]);


  useEffect(() => {
    if (!selectedPlace) return;
    //console.log("Selected Place:", selectedPlace);

    if (selectedPlace?.geometry?.location) {
      setMarkerPosition({
        lat: selectedPlace?.geometry?.location?.lat(),
        lng: selectedPlace?.geometry?.location?.lng()
      });

      if (map) {
        map.panTo( selectedPlace?.geometry?.location);
      }
    }
    if (markerRef.current) {
      markerRef.current.position = selectedPlace.geometry?.location;
    }
    if (selectedPlace !== null && onLocationSet !== undefined) {
      onLocationSet({
        place: selectedPlace,
        lat: selectedPlace?.geometry?.location?.lat() ?? 0,
        lng: selectedPlace?.geometry?.location?.lng() ?? 0,
      });
    }
  }, [selectedPlace]);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (startLat && startLng)
      setMarkerPosition({ lat: startLat, lng: startLng });
      
  }, []);

  return (
    <>
      <Map
        className={Style.map}
        onClick={mapMouseEvent}
        style={{ minHeight: "100px", minWidth: "100px", height: "500px" }}
        mapId={'a'}
        defaultZoom={startLat ? 13 : 9}
        defaultCenter={{ lat: startLat ?? 53.2, lng: startLng ?? 8.0 }}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
        zoomControl={true}
        scrollwheel={scrollZoom}
      >
        {markerPosition && <AdvancedMarker position={markerPosition} />}
      </Map>
      <MapControl position={ControlPosition.TOP} >
        <div className="autocomplete-control">
          <PlaceAutocomplete onPlaceSelect={setSelectedPlace} inputRef={inputRef} />
        </div>
      </MapControl>
      <MapHandler place={selectedPlace} marker={markerRef.current} />

    </>
  );
}

const MapComponent: React.FC<MapComponentProps> = ({ onLocationSet, startLat, startLng , scrollZoom }) => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_KEY!!;

  return (
    <APIProvider apiKey={googleMapsApiKey} solutionChannel='GMP_devsite_samples_v3_rgmautocomplete'>
      <InnerMap startLat={startLat} startLng={startLng} onLocationSet={onLocationSet} scrollZoom={scrollZoom} />
    </APIProvider>
  );
};

export default MapComponent;